import { render } from "./countdown.vue?vue&type=template&id=4b6ae5e4&scoped=true"
import script from "./countdown.vue?vue&type=script&lang=js"
export * from "./countdown.vue?vue&type=script&lang=js"

import "./countdown.vue?vue&type=style&index=0&id=4b6ae5e4&lang=less&scoped=true"

import exportComponent from "/home/bula/demo/bula2023/vue/bula2023/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b6ae5e4"]])

export default __exports__